module.exports = {
  createOutputStream: require('./create-output-stream')
}



//////////////////
// WEBPACK FOOTER
// ./~/github-download/~/fs-extra/lib/streams/index.js
// module id = 855
// module chunks = 0